import {
  SELECT_OPERATOR,
  SELECT_ALL_OPERATORS,
  REMOVE_OPERATOR,
} from "./constants";
import api from "appRedux/loginApi";
import { handleError } from "appRedux/actions/Common";
import {
  FETCH_ROUTE_DETAILS,
  FETCH_TRANSPORT_ROUTE_DETAILS_SUCCESS,
  GLOBAL_FETCH_START,
  GLOBAL_FETCH_SUCCESS,
  SUCCESSFUL_CODE,
} from "appRedux/constants";

import _ from "lodash";
import {
  FETCH_MODE_SUCCESS,
  FETCH_OPERATOR_DETAILS,
  FETCH_OPERATOR_DETAILS_SUCCESS,
  SELECTED_OPERATORS,
} from "containers/BuyOperatorToken/actions/constants";
import { config } from "constants/config";

export const fetchRouteSuccess = (data) => {
  return {
    type: FETCH_TRANSPORT_ROUTE_DETAILS_SUCCESS,
    payload: data,
  };
};
// export const fetchRoute = (whiteLabel) => {
//   return async (dispatch) => {
//     dispatch({ type: GLOBAL_FETCH_START });
//     dispatch({ type: FETCH_ROUTE_DETAILS });
//     try {
//       const response = await fetch(
//         `${config.baseUrl}/routes/whitelabel/${whiteLabel}/list/`
//       );
//       const data = await response.json();

//       const apiData = data?.data;

//       if (data.status && data.statusCode === 200) {
//         dispatch(fetchRouteSuccess(apiData));
//       } else {
//         dispatch(handleError(data.message || "Error fetching operators"));
//       }
//     } catch (error) {
//       dispatch(handleError(error.message || "Network error"));
//     } finally {
//       dispatch({ type: GLOBAL_FETCH_SUCCESS });
//     }
//   };
// };

export const fetchRoute = (whiteLabel) => {
  return async (dispatch) => {
    dispatch({ type: GLOBAL_FETCH_START });
    dispatch({ type: FETCH_ROUTE_DETAILS });

    try {
      const response = await api.get(
        `/routes/whitelabel/${whiteLabel}/list`,
        {}, // request config
        config.baseUrl // validated baseURL
      );

      const apiData = response?.data?.data;

      if (response?.data?.status && response?.data?.statusCode === 200) {
        dispatch(fetchRouteSuccess(apiData));
      } else {
        dispatch(handleError(response?.data?.message || "Error fetching operators"));
      }
    } catch (error) {
      dispatch(handleError(error?.message || "Network error"));
    } finally {
      dispatch({ type: GLOBAL_FETCH_SUCCESS });
    }
  };
};


export const fetchOperator = (id) => {
  return (dispatch) => {
    dispatch({ type: GLOBAL_FETCH_START });
    dispatch({ type: FETCH_OPERATOR_DETAILS });

    const url = `/operator/transport-mode/${id}`;
    api
      .get(url)
      .then(({ data }) => {
        if (data.status && data.statusCode === SUCCESSFUL_CODE) {
        
          const operatorData = data.data;

          // operatorData.map(operator => {
          //   operator.transport_mode = operator.transportCategories[0].id;
          //   operator.country = operator.country.id;
          // });
          dispatch(fetchOperatorSuccess(operatorData));
        } else {
          dispatch(
            handleError(
              _.isEmpty(data.message) ? "Network Error" : data.message
            )
          ); // same as "FETCH_ERROR"
        }
        dispatch({ type: GLOBAL_FETCH_SUCCESS });
      })
      .catch((error) => {
        dispatch(
          handleError(
            _.isEmpty(error.message) ? "Network Error" : error.message
          )
        ); // same as "FETCH_ERROR"
        dispatch({ type: GLOBAL_FETCH_SUCCESS });
      });
  };
};

export const getTransportModeList = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_OPERATOR_DETAILS });

    const url = "/transport_mode/list";
    api
      .get(url)
      .then(({ data }) => {
        if (data.status && data.statusCode === SUCCESSFUL_CODE) {
          const modes = data.data;
          const modeSet = modes.map((mode) => {
            return { value: mode.id, label: mode.name }; // <-- Added return
          });
          dispatch(fetchModeSuccess(modeSet)); // Dispatch the array created by map
        } else {
          dispatch(
            handleError(
              _.isEmpty(data.message) ? "Network Error" : data.message
            )
          ); // same as "FETCH_ERROR"
        }
      })
      .catch((error) => {
        dispatch(
          handleError(
            _.isEmpty(error.message) ? "Network Error" : error.message
          )
        ); // same as "FETCH_ERROR"
      });
  };
};

export const setSelectedOp = (setSelectedData) => {
  return (dispatch) => {
    dispatch({ type: FETCH_OPERATOR_DETAILS });
    dispatch({ type: SELECTED_OPERATORS, payload: setSelectedData });
  };
};

export const fetchOperatorSuccess = (data) => {
  return {
    type: FETCH_OPERATOR_DETAILS_SUCCESS,
    payload: data,
  };
};

export const fetchModeSuccess = (data) => {
  return {
    type: FETCH_MODE_SUCCESS,
    payload: data,
  };
};

export const selectOperator = (data) => {
  return {
    type: SELECT_OPERATOR,
    payload: data,
  };
};
export const selectedAllOperators = (data) => {
  return {
    type: SELECT_ALL_OPERATORS,
    payload: data,
  };
};

export const removeOperator = (id) => ({
  type: REMOVE_OPERATOR,
  payload: id,
});
